import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
// import THREE from 'three'

// import VConsole from 'vconsole'
// const vconsole = new VConsole()

Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

